import { render } from "./ElementImage.vue?vue&type=template&id=f83d7d68"
import script from "./ElementImage.vue?vue&type=script&lang=js"
export * from "./ElementImage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__